import { Grid, Box, Paper, Hidden } from "@mui/material"
import Icon from "@mdi/react"
import { mdiCellphone } from "@mdi/js"

import { Phone } from "components/i18n/Contact"

import useTranslation from "hooks/useTranslation"

import { makeStyles } from "makeStyles"

const useStyles = makeStyles()((theme) => ({
	paper: {
		padding: theme.spacing(3),
		color: "#f7fafa",
		boxShadow: "none",
		minHeight: "188px",
		borderRadius: "0",
	},
}))

const Help = () => {
	const { classes } = useStyles()
	const { t } = useTranslation("category")

	return (
		<Box mt={5} pt={5}>
			<Grid container spacing={0}>
				<Hidden smDown>
					<Grid item xs={12} sm={4}>
						<Paper
							className={classes.paper}
							style={{
								backgroundImage:
									"url(https://res.cloudinary.com/safehero/image/upload/v1571664489/Layout/HelpImage_yrruxv.png)",
							}}
						/>
					</Grid>
				</Hidden>
				<Grid item xs={12} sm={8}>
					<Paper
						className={classes.paper}
						style={{
							backgroundImage:
								"url(https://res.cloudinary.com/safehero/image/upload/v1571664489/Layout/HelpBackground2_w6r5yh.png)",
						}}
					>
						<h3>{t("helpAskAProfessional")}</h3>
						<p>
							{t("helpAskAProfessionalText")} <br />
						</p>
						<div style={{ display: "flex", alignItems: "center", fontSize: "20px" }}>
							<Icon path={mdiCellphone} size={1} color="#f7fafa" />
							<Phone />
						</div>
					</Paper>
				</Grid>
			</Grid>
		</Box>
	)
}

export default Help
